import moment from "moment/moment";
export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const languageList = [
  { value: "en", label: "English" },
  { value: "hi", label: "Hindi" },
];
export const dateReformat = (dateraw) => {
  //"2018-29-01T02:50:41+05:30"    === to ===  29January 2018
  let dateFormat = dateraw;
  try {
    dateFormat = dateFormat.split("T");
    if (typeof dateFormat === "undefined") {
      return dateraw;
    }
    var dataReformat = dateFormat[0].split("-");
    dateFormat =
      dataReformat[0] + "-" + dataReformat[2] + "-" + dataReformat[1];
    dateFormat = moment(dateFormat).format("LL");
  } catch (e) {}
  return dateFormat;
};

export const genrateguid = () => {
  return (
    s4() +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    s4() +
    s4()
  );
};

export const s4 = () => {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
};

export const getMobileOperatingSystem = () => {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
};

export const startTimer = () => {
  if (document.getElementById("timer")) {
    var presentTime = document.getElementById("timer").innerHTML;
    var timeArray = presentTime.split(/[:]+/);
    var m = timeArray[0];
    var s = checkSecond(timeArray[1] - 1);
    if (s === 59) {
      m = m - 1;
    }
    if (m < 0) {
      var element = document.getElementById("verify-event");
      if (element) {
        element.classList.add("disablebtn");
      }
      return false;
    }

    document.getElementById("timer").innerHTML = m + ":" + s;
    if (m === 0) {
      document.getElementById("min").innerHTML = " sec";
    }
    setTimeout(startTimer, 1000);
  }
  return false;
};

export const checkSecond = (sec) => {
  if (sec < 10 && sec >= 0) {
    sec = "0" + sec;
  } // add zero in front of numbers < 10
  if (sec < 0) {
    sec = "59";
  }
  return sec;
};

export const getStorageItem = (item) => {
  try {
    return JSON.parse(window.localStorage.getItem(item));
  } catch (ex) {
    return null;
  }
};

export const setStorageItem = (item, value) => {
  return window.localStorage.setItem(item, JSON.stringify(value));
};

export const SetlanguageGlobal = (lang) => {
  var Mkblang = JSON.parse(localStorage.getItem("language"));
  var detailObj = {};
  detailObj["global_lang"] = lang;
  detailObj["mkb_lang"] = Mkblang["mkb_lang"];
  window.localStorage.setItem("language", JSON.stringify(detailObj));
};

export const Capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const getDevicetype = () => {
  if (navigator.userAgent.match(/Android/i)) {
    return "Android";
  } else if (navigator.userAgent.match(/BlackBerry/i)) {
    return "BlackBerry";
  } else if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
    return "iOS";
  } else if (navigator.userAgent.match(/Opera Mini/i)) {
    return "Opera";
  } else if (navigator.userAgent.match(/IEMobile/i)) {
    return "Windows";
  } else {
    return "Android";
  }
};

export const fmtMSS = (s) => {
  return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
};
